import { useTranslation } from "react-i18next";

import { ErrorScreen } from "../ErrorScreen";

const LinkingFailure = ({
  cloudProvider = "aws",
}: {
  cloudProvider?: "aws" | "gcp";
}) => {
  const { t } = useTranslation();

  return <ErrorScreen title={t(`${cloudProvider}.failure_title`)} />;
};

export default LinkingFailure;
